import { StateUtils } from '@spartacus/core';
import { Article } from '../../../../model';
import { PyStateUtils } from '../../../../state';
import { ARTICLE } from '../../../store/catalog-state';

export enum ArticleActionTypes {
  LoadArticle = '[Catalog] Load Article',
  LoadArticleSuccess = '[Catalog] Load Article Success',
  LoadArticleFail = '[Catalog] Load Article Fail',
  LoadArticleReset = '[Catalog] Load Article Reset',
}

export class LoadArticle extends StateUtils.EntityLoadAction {
  readonly type = ArticleActionTypes.LoadArticle;

  constructor(
    public payload: string,
    public userId: string
  ) {
    super(ARTICLE, payload);
  }
}

export class LoadArticleSuccess extends StateUtils.EntitySuccessAction {
  readonly type = ArticleActionTypes.LoadArticleSuccess;

  constructor(public payload: Article) {
    super(ARTICLE, payload.code, payload);
  }
}

export class LoadArticleFail extends PyStateUtils.EntityFailAction {
  readonly type = ArticleActionTypes.LoadArticleFail;

  constructor(
    public code: string,
    public payload: any
  ) {
    super(ARTICLE, code, payload);
  }
}

export class LoadArticleReset extends StateUtils.EntityLoaderResetAction {
  readonly type = ArticleActionTypes.LoadArticleReset;

  constructor(public code: string) {
    super(ARTICLE, code);
  }
}

export type ArticleActions = LoadArticle | LoadArticleSuccess | LoadArticleFail | LoadArticleReset;
